import React, { useState } from 'react';
import { usePower } from '../state/PowerContext';
import SettingsModal from './SettingsModal';
import DangerBadge from './DangerBadge';
import { useViewDangers } from '../hooks/useViewDangers';
// Manual billing periods replaced by server-backed billing views —
// BillingPeriodManager.js kept on disk for easy revert.

export default function TopBar({ user }) {
  const { series, setSeries, theme, setTheme, views, activeView, activeViewId, setActiveViewId, activePeriod, alerts } = usePower();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const { dangerViews, dangerIds } = useViewDangers();

  return (
    <div className="topbar">
      <div className="brand">Power — Peak Watch</div>

      <div className="toggle-group" title="Data series (instant recompute)">
        <button className={series === 'LRZ4' ? 'active' : ''} onClick={() => setSeries('LRZ4')}>LRZ4</button>
        <button className={series === 'MISO' ? 'active' : ''} onClick={() => setSeries('MISO')}>MISO</button>
      </div>

      <div className="period-selector">
        <select
          value={activeViewId}
          onChange={(e) => setActiveViewId(e.target.value)}
          aria-label="Billing group shown"
          title={activeView.locations.length ? activeView.locations.join(', ') : 'Locations grouped by shared billing schedule'}
        >
          {(views.length ? views : [activeView]).map(v => (
            <option key={v.id} value={v.id}>
              {dangerIds.has(v.id) ? `🔴 ${v.optionLabel}` : v.optionLabel}
            </option>
          ))}
        </select>
        <span className="chip" title="Current pay period — read date through the day before the next read">
          {activePeriod.startISO} → {activePeriod.endISO}
        </span>
      </div>

      <DangerBadge dangerViews={dangerViews} />

      <button
        className="ghost"
        onClick={() => setSettingsOpen(true)}
        title="Alert settings"
        style={{ position: 'relative' }}
      >
        🔔
        {!alerts.enabled && <span className="mute-dot" />}
      </button>

      <button
        className="ghost"
        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
        title="Toggle theme"
      >
        {theme === 'dark' ? '☀' : '☾'}
      </button>

      {user && (
        <button
          className="ghost"
          title={`Signed in as ${user.email}`}
          onClick={() => {
            if (window.confirm(`Log out ${user.email}?`)) {
              window.location.href = '/api/auth/logout';
            }
          }}
        >
          Log out
        </button>
      )}

      {settingsOpen && <SettingsModal onClose={() => setSettingsOpen(false)} />}
    </div>
  );
}
